import React from "react";
import ReactDOM from "react-dom/client";
import { disableEmotionWarnings } from "./common/util";
import "./index.css";
import { CssVarsProvider, StyledEngineProvider } from "@mui/joy";
import { MapElement } from "./map/components/map";
import { EditControls } from "./map/components/edit-controls";

disableEmotionWarnings();

export const Entrypoint: React.FC = () => {
  return (
    <div>
      <EditControls />
      <MapElement />
    </div>
  );
};

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <StyledEngineProvider injectFirst>
    <CssVarsProvider>
      <Entrypoint />
    </CssVarsProvider>
  </StyledEngineProvider>,
);
